import moment from "moment";

function timestampToDate(timestamp) {
  let date = new Date(timestamp / 1000000);
  let now = new Date();

  var minutes = ("0" + date.getMinutes()).slice(-2);
  if (date.toLocaleDateString() == now.toLocaleDateString()) {
    return date.getHours() + ":" + minutes;
  } else if (date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate() - 1) {
    return "Hôm qua";
  } else {
    return date.getDate() + "/" + (date.getMonth() + 1);
  }
}

function timestampToDatetime(ts) {
  return moment(ts).format('DD/MM/YYYY')
}

export function groupByDay(arr) {
  const grouped = {};

  arr.forEach(obj => {
    const time = moment(Number(obj.ts))
    const date = 'Ngày ' + time.format('DD') + ' tháng ' + time.format('MM') + ', ' + time.format('YYYY')
    if (!grouped[date]) {
      grouped[date] = [];
    }
    grouped[date].push({ ...obj, date: date });
  });

  return Object.values(grouped);
}

export default { timestampToDate, timestampToDatetime };
